<template>
<div class="container">
  <app-header class="header">
    <template #top-left>
      <a href="javascript:void(0);" @click.prevent="$emit('on-cancel')" class="back-link">
        <i class="icon icon-back"></i>Cancel
      </a>
    </template>
    <template #top-middle>
      <h3 class="app-component-header__title">Group Settings</h3>
    </template>
  </app-header>
  <div class="manage">
    <div
        class="manage__item"
    >
      <i class="icon manage__icon icon-settings2"></i>
      <div class="manage__container">
        <h3 class="manage__title">
          Archive Group
        </h3>
        <p class="manage__text">
        </p>
        New members won’t be able to join this group,
        Existing members won’t be able to post, comment, or share any of the content.
      </div>
    </div>
    <div
        class="manage__item"
    >
      <i class="icon manage__icon icon-settings2"></i>
      <div class="manage__container">
        <h3 class="manage__title">
          Leave Group
        </h3>
        <p class="manage__text">
          You are the owner of this group. If you leave the group, you need to choose a new owner.
        </p>
      </div>
    </div>
    <div
      @click="deleteGroup"
      class="manage__item manage__item-last"
    >
      <i class="icon manage__icon icon-settings2"></i>
      <div class="manage__container">
        <h3 class="manage__title">
          Delete Group
        </h3>
        <p class="manage__text">
          The group and all content in the group will be permanently deleted. This can’t be undone.
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { useRouter } from 'vue-router';
import AppHeader from '@/components/AppHeader.vue';
import SpacesService from '@/modules/spaces/services/SpacesService';

export default {
  name: 'GroupSettingsPopup',
  props: {
    groupData: { type: Object, required: true },
  },
  components: {
    AppHeader,
  },
  setup(props) {
    const router = useRouter();

    function deleteGroup() {
      SpacesService.deleteGroup(props.groupData.id).then((res) => {
        if (res.success) {
          router.push('/spaces/groups');
        }
      });
    }
    return {
      deleteGroup,
    };
  },
};
</script>

<style lang="sass" scoped>
.container
  position: fixed
  width: 100%
  height: 100%
  padding: 20px
  top: 0
  left: 0
  z-index: 1001
  background: #ffffff

.manage
  font-size: 14px
  color: #2C353B
  margin: 0 auto

  &__container
    margin-left: 10px

  &__title
    margin: 0
    font-weight: 600

  &__text
    margin: 0
    word-wrap: break-word

  &__item
    display: flex
    align-items: flex-start
    justify-content: flex-start
    padding: 16px 0
    border-top: 1px solid #C8D4DB

  &__item-last
    border-bottom: 1px solid #C8D4DB

.icon
  font-size: 20px
  line-height: 32px
</style>
